import { makeStyles } from "@material-ui/core/styles";
import ErrorPageBg from "../../../assets/images/empty-state/error-page-bg.svg";
import ErrorPageBottomBg from "../../../assets/images/empty-state/error-page-bottom-bg.svg";

const useStyles = makeStyles(theme => ({
  root: {
    position: "fixed",
    zIndex: 9999999,
    background: "#fff",
    left: 0,
    top: 0,
    height: "100%",
    width: "100%",
    "& header": {
      background: "#F0F2F6",
      textAlign: "center",
      padding: "20px 0",
      "& img": {
        width: 100,
      },
    },
  },
  ErrorPageBottomBg: {
    background: `url(${ErrorPageBottomBg}) no-repeat`,
    backgroundPosition: "bottom",
    backgroundSize: "cover",
    height: 200,
    position: "absolute",
    bottom: 0,
    width: "100%",
  },
  content: {
    background: `url(${ErrorPageBg}) no-repeat`,
    backgroundPosition: "center",
    height: "100%",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    [theme.breakpoints.down("xs")]: {
      width: "80%",
      margin: "auto",
      textAlign: "center",
    },
    "& h1": {
      fontWeight: 400,
      color: "#EE404C",
      margin: 0,
      fontSize: 38,
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        fontSize: 30,
      },
      "& svg": {
        fontSize: 34,
        marginRight: 10,
      },
    },
    "& h2": {
      fontWeight: 400,
      margin: "10px 0",
      [theme.breakpoints.down("xs")]: {
        fontSize: 16,
      },
    },
  },
}));

export default useStyles;
